import type { FunctionComponent } from 'react';

import { useDescriptionMarkStates } from './use-description-mark-states';

type DescriptionMarkStatesProps = {
    readonly itemId: string;
};

export const DescriptionMarkStates: FunctionComponent<DescriptionMarkStatesProps> = ({ itemId }) => {
    useDescriptionMarkStates(itemId);
    return null;
};
